var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationV3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25C15.7177 2.25 18.75 5.23946 18.75 8.9502C18.75 9.83367 18.5678 10.669 18.2607 11.4316L18.1211 11.7539C18.1165 11.7638 18.1114 11.7735 18.1064 11.7832L12.667 22.3438C12.5384 22.5933 12.2808 22.75 12 22.75C11.7192 22.75 11.4616 22.5933 11.333 22.3438L5.89355 11.7832C5.88976 11.7758 5.88539 11.7682 5.88184 11.7607C5.47586 10.9035 5.25003 9.95427 5.25 8.9502C5.25 5.23946 8.28234 2.25 12 2.25Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 3,
    stroke: "current",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationV3);
export default __webpack_public_path__ + "static/media/locationV3.337c68991bef16623ff958cffdcf5bcb.svg";
export { ForwardRef as ReactComponent };